import React from "react";
import TextCopy from "../../Reusable/TextCopy";

interface CustomerContactInfoProps {
  title: string;
  value: string;
  mt?: string;
  border?: string;
  color?: string;
}
export const CustomerContactInfo: React.FC<CustomerContactInfoProps> = ({
  title,
  value,
  mt = "",
  border = "",
  color = "",
}) => (
  <div
    className={`flex md:flex-col  justify-between md:justify-normal w-full md:w-fit items-center border-b-${border} border-b md:border-0 px-3 md:px-0`}
  >
    <h3
      className={`font-normal text-[#808080] text-[14px] leading-[14.4px] ${mt} `}
    >
      {title}
    </h3>
    {title == "Phone Number" ? (
      <TextCopy text={value || ""} />
    ) : (
      <p
        className={`font-medium text-[16px] md:text-[14px] leading-[18.4px] mt-2 text-gray-700`}
        style={{ color }}
      >
        {value}
      </p>
    )}
  </div>
);
